import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

// PrimeNG
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RBI_OVERLAY_Z_INDEX, RBI_PRIMENG_OPTIONS, RBI_PRIMENG_PRESET, RBI_PRIMENG_TRANSLATION } from './core/config/primeng-theme.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),

    providePrimeNG({
      license: 'eyJpZCI6ImQ2YzAxNGI5LTU2NDgtNDc2Zi05NGY2LTkzYmNhMzVhYjM5ZCIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODgzNTk0NjAsImV4cCI6MTgxOTg5NTQ2MH0.3xpigCjRnZH7uQp6-CKtRcBv2pGLQxAyvV2hjjpb7r1QTnsCb60vqjQjOfn4vEsA8RmLezF_m8godoEfbFpADw',
      theme: {
        preset: RBI_PRIMENG_PRESET,
        options: RBI_PRIMENG_OPTIONS
      },
      ripple: true,
      zIndex: RBI_OVERLAY_Z_INDEX,
      translation: RBI_PRIMENG_TRANSLATION
    }),
    MessageService,
    ConfirmationService,
  ]
};
